import { companiesId } from 'Utils/constants'

/**
 * Checks whether a given company ID is part of the allowed companies list.
 *
 * This function is used to conditionally enable or disable features
 * depending on the company context. If the company ID is not found
 * in the `companiesId` list (e.g., Punto Cochez or others not explicitly allowed),
 * related features (like generating sales orders or catalog PDFs) should be omitted.
 *
 * @param {string} companyId - The ID of the company to check.
 * @returns {boolean} `true` if the company is allowed; `false` otherwise.
 */
export const isAllowedCompany = companyId => {
  const ALLOWED_COMPANIES = [companiesId.cochez, companiesId.novey]

  return ALLOWED_COMPANIES.includes(companyId)
}
